export default __webpack_public_path__ + "static/media/user.010bc77d.svg";